<template>
    <div class="warn-index">
        <div class="body-title">消息提醒设置</div>
        <div class="sub-title margin-top20">
            <el-row>
                <el-col :span="12">
                    <div>新消息提醒</div>
                    <div class="gray">新消息弹框提醒</div>
                </el-col>
                <!-- <el-col :span="12">&nbsp;</el-col> -->
                <el-col :span="12">
                    <el-switch
                        v-model="newMessageWarn"
                        :active-value="true"
                        :inactive-value="false"
                        @change="globalSetting"
                    ></el-switch>
                </el-col>
            </el-row>
        </div>
        <div class="margin-top20">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F9F9F9' }">
                <el-table-column prop="messageTypeName" label="消息类型"></el-table-column>
                <el-table-column prop="webIfNotify" label="PC端">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.webIfNotify"
                            :inactive-value="false"
                            :active-value="true"
                            @change="switchStatus(scope.row, 'pc')"
                        ></el-switch>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="app" label="APP">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.app"
              @change="switchStatus(scope.row,'app')"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
          </template>
        </el-table-column>-->
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: "WarnIndex",
    data() {
        return {
            newMessageWarn: true,
            api_post_globalSetting: "/admin/userMessage/saveGlobalSetting",
            api_get_setting: "/admin/userMessage/getSettings",
            api_post_singleSetting: "/admin/userMessage/saveSetting",
            tableData: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.$axios.get(this.api_get_setting).then((res) => {
                this.loading = false;
                if (res.body) {
                    this.newMessageWarn = res.body.globalSetting;
                    this.tableData = res.body.settings;
                }
            });
        },
        switchStatus(row, type) {
            let param = {
                settingId: row.settingId,
                webIfNotify: row.webIfNotify,
                appIfNotify: row.appIfNotify,
            };
            this.$axios.post(this.api_post_singleSetting, param).then((res) => {
                this.loading = false;
                this.init();
                this.$message.success("单个设置成功");
            });
        },
        // 全局消息提醒切换
        globalSetting() {
            this.$axios
                .post(this.api_post_globalSetting, {
                    globalSetting: this.newMessageWarn,
                })
                .then((res) => {
                    this.loading = false;
                    this.$message.success("全局设置成功");
                    this.init();
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.warn-index {
    .body-title {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .sub-title {
        font-size: 14px;
        .gray {
            color: #999999;
        }
    }
    .margin-top20 {
        margin-top: 20px;
    }
}
</style>
